import JustValidate from 'just-validate'

export default class ContactForm {
    static init() {
        console.log('== Contact Form component ==')

        const form = document.querySelector('#contact-form')
        const formSubmittButton = form.querySelector('.form-button.submit')

        let postBody = {}

        // init validation
        const validation = new JustValidate('#contact-form')

        validation
            .addField('#contactName', [
                {
                    rule: 'required',
                    errorMessage: 'Il campo nome è obbligatorio',
                },
            ])
            .addField('#contactSurname', [
                {
                    rule: 'required',
                    errorMessage: 'Il campo cognome è obbligatorio',
                },
            ])
            .addField('#contactEmail', [
                {
                    rule: 'required',
                    errorMessage: 'Il campo email è obbligatorio',
                },
                {
                    rule: 'email',
                    errorMessage: 'Il formato dell\'email non è valido',
                },
            ])
            .addField('#contactPhone', [
                {
                    rule: 'required',
                    errorMessage: 'Il campo telefono è obbligatorio',
                },
            ])
            .addField('#contactPrivacy', [
                {
                    rule: 'required',
                    errorMessage: 'Devi accettare la privacy policy per procedere',
                },
            ])
            .onSuccess((event) => {
                formSubmittButton.classList.add('h-disabled')

                postBody = {
                    contactName: form.elements.contactName.value,
                    contactSurname: form.elements.contactSurname.value,
                    contactPhone: form.elements.contactPhone.value,
                    contactEmail: form.elements.contactEmail.value,
                    contactMessage: form.elements.contactMessage?.value || '',
                }

                const formSubmissionMsgOK = document.querySelector(
                    '.form-submission-message.success'
                )
                const formSubmissionMsgKO = document.querySelector(
                    '.form-submission-message.error'
                )

                const asyncPostCall = async () => {
                    formSubmissionMsgOK.classList.remove('show')
                    formSubmissionMsgKO.classList.remove('show')

                    if (form.elements.foodNeeds.value) {
                        formSubmissionMsgOK.classList.add('show')
                        formSubmittButton.classList.remove('h-disabled')
                        form.reset()
                    } else {
                        try {
                            // Usa WordPress AJAX invece di chiamare direttamente il file PHP
                            const formData = new FormData()
                            formData.append('action', 'submit_contact_form')
                            formData.append('contactName', postBody.contactName)
                            formData.append('contactSurname', postBody.contactSurname)
                            formData.append('contactPhone', postBody.contactPhone)
                            formData.append('contactEmail', postBody.contactEmail)
                            formData.append('contactMessage', postBody.contactMessage)

                            const response = await fetch('/wp-admin/admin-ajax.php', {
                                method: 'POST',
                                body: formData,
                            })

                            const result = await response.json()

                            if (result.success) {
                                formSubmissionMsgOK.classList.add('show')
                                form.reset()
                            } else {
                                formSubmissionMsgKO.classList.add('show')
                                console.error('Error:', result.data)
                            }

                            formSubmittButton.classList.remove('h-disabled')
                        } catch (error) {
                            formSubmissionMsgKO.classList.add('show')
                            formSubmittButton.classList.remove('h-disabled')
                            console.error('Fetch error:', error)
                        }
                    }
                }

                asyncPostCall()
            })
    }
}
